// CREATE_ASSIGN PROCESS
export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK';
export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK';
export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK';

// FETCH ALL ASSIGN PROCESS
export const FETCH_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK = 'FETCH_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK';
export const FETCH_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK = 'FETCH_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK';
export const FETCH_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK = 'FETCH_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK';

// DELETE PROCESS
export const DELETE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK = 'DELETE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK';
export const DELETE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK = 'DELETE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK';
export const DELETE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK = 'DELETE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK';

// UPDATE PROCESS_ASSIGN_STYLE_MASTER
export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK';
export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK';
export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK';

// FETCH SINGLE STATE OF PROCESS_ASSIGN_STYLE_MASTER
export const FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK = 'FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK';
export const FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK = 'FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK';
export const FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK = 'FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK';

export const RESET_PROCESS_ASSIGN_STYLE_MASTER_INFO_DK = 'RESET_PROCESS_ASSIGN_STYLE_MASTER_INFO_DK';

export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_FORM_DK = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_FORM_DK';

export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FORM_DK = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FORM_DK';
